import { Injectable } from "@angular/core";
import { loadMessages } from "devextreme/localization";

@Injectable({
  providedIn: "root"
})
export class DevExtremeMessageLoaderService {
  loadMessages(languageId: string) {
    if (!this.isNorwegian(languageId)) { return; }
    this.loadNorwegianMessages();
  }

  private isNorwegian(languageId: string): boolean {
    return parseInt(languageId, 10) === 1;
  }

  private loadNorwegianMessages() {
    loadMessages({
      en: {
        Yes: "Ja",
        No: "Nei",
        Cancel: "Avbryt",
        Clear: "Blank",
        Done: "Ferdig",
        Loading: "Laster...",
        Select: "Velg...",
        Search: "Søk",
        Back: "Tilbake",
        OK: "OK",

        "dxCollectionWidget-noDataText": "Ingen data å vise",

        "dxDropDownEditor-selectLabel": "Velg",

        "validation-required": "Påkrevd",
        "validation-required-formatted": "{0} er påkrevd",
        "validation-numeric": "Verdi må være et nummer",
        "validation-numeric-formatted": "{0} må være et nummer",
        "validation-range": "Verdi er utenfor området",
        "validation-range-formatted": "{0} er utenfor området",
        "validation-stringLength": "Lengden på verdi er ikke korrekt",
        "validation-stringLength-formatted": "Lengden på {0} er ikke korrekt",
        "validation-custom": "Verdi er ugyldig",
        "validation-custom-formatted": "{0} er ugyldig",
        "validation-async": "Verdi er ugyldig",
        "validation-async-formatted": "{0} er ugyldig",
        "validation-compare": "Verdier stemmer ikke overens",
        "validation-compare-formatted": "{0} stemmer ikke overens",
        "validation-pattern": "Verdier stemmer ikke overens med mønster",
        "validation-pattern-formatted": "{0} stemmer ikke overens med mønster",
        "validation-email": "Epost er ugyldig",
        "validation-email-formatted": "{0} er ugyldig",
        "validation-mask": "Verdi er ugyldig",

        "dxLookup-searchPlaceholder": "Minimum antall tegn: {0}",

        "dxList-pullingDownText": "Trekk ned for å oppdatere...",
        "dxList-pulledDownText": "Slipp for å oppdatere...",
        "dxList-refreshingText": "Oppdaterer...",
        "dxList-pageLoadingText": "Laster...",
        "dxList-nextButtonText": "Mer",
        "dxList-selectAll": "Velg alle",
        "dxListEditDecorator-delete": "Slett",
        "dxListEditDecorator-more": "Mer",

        "dxScrollView-pullingDownText": "Trekk ned for å oppdatere...",
        "dxScrollView-pulledDownText": "Slipp for å oppdatere...",
        "dxScrollView-refreshingText": "Oppdaterer...",
        "dxScrollView-reachBottomText": "Laster...",

        "dxDateBox-simulatedDataPickerTitleTime": "Velg tid",
        "dxDateBox-simulatedDataPickerTitleDate": "Velg dato",
        "dxDateBox-simulatedDataPickerTitleDateTime": "Velg dato og tid",
        "dxDateBox-validation-datetime": "Verdi må være en dato eller et klokkeslett",

        "dxFileUploader-selectFile": "Velg fil",
        "dxFileUploader-dropFile": "eller slipp fil her",
        "dxFileUploader-bytes": "bytes",
        "dxFileUploader-kb": "kb",
        "dxFileUploader-Mb": "Mb",
        "dxFileUploader-Gb": "Gb",
        "dxFileUploader-upload": "Last opp",
        "dxFileUploader-uploaded": "Opplastet",
        "dxFileUploader-readyToUpload": "Klar til å laste opp",
        "dxFileUploader-uploadAbortedMessage": "Opplasting avbrutt",
        "dxFileUploader-uploadFailedMessage": "Opplasting feilet",
        "dxFileUploader-invalidFileExtension": "Filtype er ikke godkjent",
        "dxFileUploader-invalidMaxFileSize": "Filen er for stor",
        "dxFileUploader-invalidMinFileSize": "Filen er for liten",

        "dxRangeSlider-ariaFrom": "Fra",
        "dxRangeSlider-ariaTill": "Til",
        "dxSwitch-switchedOnText": "Ja",
        "dxSwitch-switchedOffText": "Nei",

        "dxForm-optionalMark": "Valgfri",
        "dxForm-requiredMessage": "{0} er påkrevd",

        "dxNumberBox-invalidValueMessage": "Verdi må være et nummer",
        "dxNumberBox-noDataText": "Ingen data",

        "dxDataGrid-columnChooserTitle": "Kolonnevelger",
        "dxDataGrid-columnChooserEmptyText": "Dra en kolonne hit for å skjule den",
        "dxDataGrid-groupContinuesMessage": "Fortsetter på neste side",
        "dxDataGrid-groupContinuedMessage": "Fortsatt fra forrige side",
        "dxDataGrid-groupHeaderText": "Grupper på denne kolonnen",
        "dxDataGrid-ungroupHeaderText": "Opphev gruppering",
        "dxDataGrid-ungroupAllText": "Opphev alle grupperinger",
        "dxDataGrid-editingEditRow": "Endre",
        "dxDataGrid-editingSaveRowChanges": "Lagre",
        "dxDataGrid-editingCancelRowChanges": "Avbryt",
        "dxDataGrid-editingDeleteRow": "Slett",
        "dxDataGrid-editingUndeleteRow": "Angre",
        "dxDataGrid-editingConfirmDeleteMessage": "Er du sikker på at du vil slette denne posten?",
        "dxDataGrid-validationCancelChanges": "Avbryt endringer",
        "dxDataGrid-groupPanelEmptyText": "Dra en kolonneoverkrift her for å gruppere",
        "dxDataGrid-noDataText": "Ingen data",
        "dxDataGrid-searchPanelPlaceholder": "Søk...",
        "dxDataGrid-filterRowShowAllText": "(Alle)",
        "dxDataGrid-filterRowResetOperationText": "Nullstill",
        "dxDataGrid-filterRowOperationEquals": "Er lik",
        "dxDataGrid-filterRowOperationNotEquals": "Er ulik",
        "dxDataGrid-filterRowOperationLess": "Mindre enn",
        "dxDataGrid-filterRowOperationLessOrEquals": "Mindre enn eller lik",
        "dxDataGrid-filterRowOperationGreater": "Større enn",
        "dxDataGrid-filterRowOperationGreaterOrEquals": "Større enn eller lik",
        "dxDataGrid-filterRowOperationStartsWith": "Begynner med",
        "dxDataGrid-filterRowOperationContains": "Inneholder",
        "dxDataGrid-filterRowOperationNotContains": "Inneholder ikke",
        "dxDataGrid-filterRowOperationEndsWith": "Slutter med",
        "dxDataGrid-filterRowOperationBetween": "Mellom",
        "dxDataGrid-filterRowOperationBetweenStartText": "Start",
        "dxDataGrid-filterRowOperationBetweenEndText": "Slutt",
        "dxDataGrid-applyFilterText": "Påfør filter",
        "dxDataGrid-trueText": "sant",
        "dxDataGrid-falseText": "usant",
        "dxDataGrid-sortingAscendingText": "Sorter stigende",
        "dxDataGrid-sortingDescendingText": "Sorter synkende",
        "dxDataGrid-sortingClearText": "Nullstill sortering",
        "dxDataGrid-editingSaveAllChanges": "Lagre endringer",
        "dxDataGrid-editingCancelAllChanges": "Forkast endringer",
        "dxDataGrid-editingAddRow": "Legg til en rad",
        "dxDataGrid-summaryMin": "Min: {0}",
        "dxDataGrid-summaryMinOtherColumn": "Min av {1} er {0}",
        "dxDataGrid-summaryMax": "Max: {0}",
        "dxDataGrid-summaryMaxOtherColumn": "Max av {1} er {0}",
        "dxDataGrid-summaryAvg": "Avg: {0}",
        "dxDataGrid-summaryAvgOtherColumn": "Avg av {1} er {0}",
        "dxDataGrid-summarySum": "Sum: {0}",
        "dxDataGrid-summarySumOtherColumn": "Sum av {1} er {0}",
        "dxDataGrid-summaryCount": "Antall: {0}",
        "dxDataGrid-columnFixingFix": "Fiks",
        "dxDataGrid-columnFixingUnfix": "Fjern fiks",
        "dxDataGrid-columnFixingLeftPosition": "Til venstre",
        "dxDataGrid-columnFixingRightPosition": "Til høyre",
        "dxDataGrid-exportTo": "Eksporter",
        "dxDataGrid-exportToExcel": "Eksporter til Excel fil",
        "dxDataGrid-exporting": "Eksporterer...",
        "dxDataGrid-excelFormat": "Excel fil",
        "dxDataGrid-selectedRows": "Valgte rader",
        "dxDataGrid-exportSelectedRows": "Eksporter valgte rader",
        "dxDataGrid-exportAll": "Eksporter alt",
        "dxDataGrid-headerFilterEmptyValue": "(Blanke)",
        "dxDataGrid-headerFilterOK": "OK",
        "dxDataGrid-headerFilterCancel": "Avbryt",
        "dxDataGrid-ariaAdaptiveCollapse": "Skjul tilleggsdata",
        "dxDataGrid-ariaAdaptiveExpand": "Vis tilleggsdata",
        "dxDataGrid-ariaColumn": "Kolonne",
        "dxDataGrid-ariaValue": "Verdi",
        "dxDataGrid-ariaFilterCell": "Filtrer celle",
        "dxDataGrid-ariaCollapse": "Kollaps",
        "dxDataGrid-ariaExpand": "Ekspander",
        "dxDataGrid-ariaDataGrid": "Datagrid",
        "dxDataGrid-ariaSearchInGrid": "Søk i datagriden",
        "dxDataGrid-ariaSelectAll": "Velg alle",
        "dxDataGrid-ariaSelectRow": "Velg rad",
        "dxDataGrid-ariaToolbar": "Data grid toolbar",
        "dxDataGrid-filterBuilderPopupTitle": "Filter bygger",
        "dxDataGrid-filterPanelCreateFilter": "Lag Filter",
        "dxDataGrid-filterPanelClearFilter": "Blank",
        "dxDataGrid-filterPanelFilterEnabledHint": "Aktiver filteret",

        "dxTreeList-ariaTreeList": "Treliste",
        "dxTreeList-ariaSearchInGrid": "Søk i trelisten",
        "dxTreeList-ariaToolbar": "Treliste toolbar",
        "dxTreeList-editingAddRowToNode": "Legg til",

        "dxPager-infoText": "Side {0} av {1} ({2} elementer)",
        "dxPager-pagesCountText": "av",
        "dxPager-pageSizesAllText": "Alle",

        "dxPivotGrid-grandTotal": "Total",
        "dxPivotGrid-total": "{0} Total",
        "dxPivotGrid-fieldChooserTitle": "Feltvelger",
        "dxPivotGrid-showFieldChooser": "Vis feltvelger",
        "dxPivotGrid-expandAll": "Ekspander alle",
        "dxPivotGrid-collapseAll": "Kollaps alle",
        "dxPivotGrid-sortColumnBySummary": "Sorter \"{0}\" på denne kolonnen",
        "dxPivotGrid-sortRowBySummary": "Sorter \"{0}\" på denne raden",
        "dxPivotGrid-removeAllSorting": "Fjern all sortering",
        "dxPivotGrid-dataNotAvailable": "N/A",
        "dxPivotGrid-rowFields": "Radfelter",
        "dxPivotGrid-columnFields": "Kolonnefelter",
        "dxPivotGrid-dataFields": "Datafelter",
        "dxPivotGrid-filterFields": "Filterfelter",
        "dxPivotGrid-allFields": "Alle felter",
        "dxPivotGrid-columnFieldArea": "Slipp kolonnefelter her",
        "dxPivotGrid-dataFieldArea": "Slipp datafelter her",
        "dxPivotGrid-rowFieldArea": "Slipp radfelter her",
        "dxPivotGrid-filterFieldArea": "Slipp filterfelter her",

        "dxScheduler-editorLabelTitle": "Emne",
        "dxScheduler-editorLabelStartDate": "Startdato",
        "dxScheduler-editorLabelEndDate": "Sluttdato",
        "dxScheduler-editorLabelDescription": "Beskrivelse",
        "dxScheduler-editorLabelRecurrence": "Gjenta",

        "dxScheduler-openAppointment": "Åpne avtale",

        "dxScheduler-recurrenceNever": "Aldri",
        "dxScheduler-recurrenceMinutely": "Hvert minutt",
        "dxScheduler-recurrenceHourly": "Hver time",
        "dxScheduler-recurrenceDaily": "Hver dag",
        "dxScheduler-recurrenceWeekly": "Ukentlig",
        "dxScheduler-recurrenceMonthly": "Månedlig",
        "dxScheduler-recurrenceYearly": "Årlig",

        "dxScheduler-recurrenceRepeatEvery": "Gjenta hver",
        "dxScheduler-recurrenceRepeatOn": "Gjenta på",
        "dxScheduler-recurrenceEnd": "Avslutt gjentakelse",
        "dxScheduler-recurrenceAfter": "Etter",
        "dxScheduler-recurrenceOn": "På",

        "dxScheduler-recurrenceRepeatMinutely": "minutt(er)",
        "dxScheduler-recurrenceRepeatHourly": "time(r)",
        "dxScheduler-recurrenceRepeatDaily": "dag(er)",
        "dxScheduler-recurrenceRepeatWeekly": "uke(r)",
        "dxScheduler-recurrenceRepeatMonthly": "måned(er)",
        "dxScheduler-recurrenceRepeatYearly": "år",

        "dxScheduler-switcherDay": "Dag",
        "dxScheduler-switcherWeek": "Uke",
        "dxScheduler-switcherWorkWeek": "Arbeidsuke",
        "dxScheduler-switcherMonth": "Måned",

        "dxScheduler-switcherAgenda": "Dagsordren",

        "dxScheduler-switcherTimelineDay": "Tidslinje dag",
        "dxScheduler-switcherTimelineWeek": "Tidslinje uke",
        "dxScheduler-switcherTimelineWorkWeek": "Tidslinje arbeidsuke",
        "dxScheduler-switcherTimelineMonth": "Tidslinje måned",

        "dxScheduler-recurrenceRepeatOnDate": "på dato",
        "dxScheduler-recurrenceRepeatCount": "forekomst(er)",
        "dxScheduler-allDay": "Hele dagen",

        "dxScheduler-confirmRecurrenceEditMessage": "Vil du redigere bare denne avtalen eller hele serien?",
        "dxScheduler-confirmRecurrenceDeleteMessage": "Vil du slette bare denne avtalen eller hele serien?",

        "dxScheduler-confirmRecurrenceEditSeries": "Rediger serier",
        "dxScheduler-confirmRecurrenceDeleteSeries": "Slett serier",
        "dxScheduler-confirmRecurrenceEditOccurrence": "Rediger avtale",
        "dxScheduler-confirmRecurrenceDeleteOccurrence": "Slett avtale",

        "dxScheduler-noTimezoneTitle": "Ingen tidssone",
        "dxScheduler-moreAppointments": "{0} mer",

        "dxCalendar-todayButtonText": "I dag",
        "dxCalendar-ariaWidgetName": "Kalender",

        "dxColorView-ariaRed": "Rød",
        "dxColorView-ariaGreen": "Grønn",
        "dxColorView-ariaBlue": "Blå",
        "dxColorView-ariaAlpha": "Åpenhet",
        "dxColorView-ariaHex": "Fargekode",

        "dxTagBox-selected": "{0} valgt",
        "dxTagBox-allSelected": "Alle valgte ({0})",
        "dxTagBox-moreSelected": "{0} mer",

        "vizExport-printingButtonText": "Skriv ut",
        "vizExport-titleMenuText": "Eksporterer/Skriver ut",
        "vizExport-exportButtonText": "{0} fil",

        "dxFilterBuilder-and": "Og",
        "dxFilterBuilder-or": "Eller",
        "dxFilterBuilder-notAnd": "Ikke Og",
        "dxFilterBuilder-notOr": "Ikke Eller",
        "dxFilterBuilder-addCondition": "Legg til tilstand",
        "dxFilterBuilder-addGroup": "Legg til gruppe",
        "dxFilterBuilder-enterValueText": "<skriv inn en verdi>",
        "dxFilterBuilder-filterOperationEquals": "Er lik",
        "dxFilterBuilder-filterOperationNotEquals": "Er ulik",
        "dxFilterBuilder-filterOperationLess": "Er mindre enn",
        "dxFilterBuilder-filterOperationLessOrEquals": "Er mindre enn eller lik",
        "dxFilterBuilder-filterOperationGreater": "Er større enn",
        "dxFilterBuilder-filterOperationGreaterOrEquals": "Er større enn eller lik",
        "dxFilterBuilder-filterOperationStartsWith": "Begynner med",
        "dxFilterBuilder-filterOperationContains": "Inneholder",
        "dxFilterBuilder-filterOperationNotContains": "Inneholder ikke",
        "dxFilterBuilder-filterOperationEndsWith": "Slutter med",
        "dxFilterBuilder-filterOperationIsBlank": "Er blank",
        "dxFilterBuilder-filterOperationIsNotBlank": "Er ikke blank",
        "dxFilterBuilder-filterOperationBetween": "Er mellom",
        "dxFilterBuilder-filterOperationAnyOf": "Er noen av",
        "dxFilterBuilder-filterOperationNoneOf": "Er ingen av",

        "dxHtmlEditor-dialogColorCaption": "Endre Fontfarge",
        "dxHtmlEditor-dialogBackgroundCaption": "Endre Bakgrunnsfarge",
        "dxHtmlEditor-dialogLinkCaption": "Legg til Lenke",
        "dxHtmlEditor-dialogLinkUrlField": "URL",
        "dxHtmlEditor-dialogLinkTextField": "Tekst",
        "dxHtmlEditor-dialogLinkTargetField": "Åpne lenke i nytt vindu",
        "dxHtmlEditor-dialogImageCaption": "Legg til bilde",
        "dxHtmlEditor-dialogImageUrlField": "URL",
        "dxHtmlEditor-dialogImageAltField": "Alternativ tekst",
        "dxHtmlEditor-dialogImageWidthField": "Bredde (px)",
        "dxHtmlEditor-dialogImageHeightField": "Høyde (px)",
        "dxHtmlEditor-dialogInsertTableRowsField": "Rader",
        "dxHtmlEditor-dialogInsertTableColumnsField": "Kolonner",
        "dxHtmlEditor-dialogInsertTableCaption": "Legg inn tabell",
        "dxHtmlEditor-heading": "Overskrift",
        "dxHtmlEditor-normalText": "Normal tekst",
        "dxHtmlEditor-background": "Bakgrunnsfarge",
        "dxHtmlEditor-bold": "Uthevet",
        "dxHtmlEditor-color": "Fontfarge",
        "dxHtmlEditor-font": "Font",
        "dxHtmlEditor-italic": "Italic",
        "dxHtmlEditor-link": "Legg til lenke",
        "dxHtmlEditor-image": "Legg til bilde",
        "dxHtmlEditor-size": "Størrelse",
        "dxHtmlEditor-strike": "Gjennomstreket",
        "dxHtmlEditor-subscript": "Subscript",
        "dxHtmlEditor-superscript": "Superscript",
        "dxHtmlEditor-underline": "Understrek",
        "dxHtmlEditor-blockquote": "Blockquote",
        "dxHtmlEditor-header": "Overskrift",
        "dxHtmlEditor-increaseIndent": "Øk innrykk",
        "dxHtmlEditor-decreaseIndent": "Reduser innrykk",
        "dxHtmlEditor-orderedList": "Sortert liste",
        "dxHtmlEditor-bulletList": "Punktliste",
        "dxHtmlEditor-alignLeft": "Juster venstre",
        "dxHtmlEditor-alignCenter": "Midtstill",
        "dxHtmlEditor-alignRight": "Juster høyre",
        "dxHtmlEditor-alignJustify": "Align Justify",
        "dxHtmlEditor-codeBlock": "Kodeblokk",
        "dxHtmlEditor-variable": "Legg til variabel",
        "dxHtmlEditor-undo": "Angre",
        "dxHtmlEditor-redo": "Gjør om",
        "dxHtmlEditor-clear": "Fjern formattering",
        "dxHtmlEditor-insertTable": "Sett inn tabell",
        "dxHtmlEditor-insertRowAbove": "Sett inn rad over",
        "dxHtmlEditor-insertRowBelow": "Sett inn rad under",
        "dxHtmlEditor-insertColumnLeft": "Sett inn kolonne til venstre",
        "dxHtmlEditor-insertColumnRight": "Sett inn kolonne til høyre",
        "dxHtmlEditor-deleteColumn": "Slett kolonne",
        "dxHtmlEditor-deleteRow": "Slett rad",
        "dxHtmlEditor-deleteTable": "Slett tabell",
        "dxHtmlEditor-list": "Liste",
        "dxHtmlEditor-ordered": "Sortert",
        "dxHtmlEditor-bullet": "Punkt",
        "dxHtmlEditor-align": "Juster",
        "dxHtmlEditor-center": "Midtstill",
        "dxHtmlEditor-left": "Venstre",
        "dxHtmlEditor-right": "Høyre",
        "dxHtmlEditor-indent": "Innrykk",
        "dxHtmlEditor-justify": "Juster",

        // "dxFileManager-newDirectoryName": "Untitled directory",
        // "dxFileManager-rootDirectoryName": "Files",
        // "dxFileManager-errorNoAccess": "Access Denied. Operation could not be completed.",
        // "dxFileManager-errorDirectoryExistsFormat": "Directory '{0}' already exists.",
        // "dxFileManager-errorFileExistsFormat": "File '{0}' already exists.",
        // "dxFileManager-errorFileNotFoundFormat": "File '{0}' not found.",
        // "dxFileManager-errorDirectoryNotFoundFormat": "Directory '{0}' not found.",
        // "dxFileManager-errorWrongFileExtension": "File extension is not allowed.",
        // "dxFileManager-errorMaxFileSizeExceeded": "File size exceeds the maximum allowed size.",
        // "dxFileManager-errorInvalidSymbols": "This name contains invalid characters.",
        // "dxFileManager-errorDefault": "Unspecified error.",
        // "dxFileManager-errorDirectoryOpenFailed": "The directory cannot be opened",

        // "dxFileManager-commandCreate": "New directory",
        // "dxFileManager-commandRename": "Rename",
        // "dxFileManager-commandMove": "Move to",
        // "dxFileManager-commandCopy": "Copy to",
        // "dxFileManager-commandDelete": "Delete",
        // "dxFileManager-commandDownload": "Download",
        // "dxFileManager-commandUpload": "Upload files",
        // "dxFileManager-commandRefresh": "Refresh",
        // "dxFileManager-commandThumbnails": "Thumbnails View",
        // "dxFileManager-commandDetails": "Details View",
        // "dxFileManager-commandClearSelection": "Clear selection",
        // "dxFileManager-commandShowNavPane": "Toggle navigation pane",

        // "dxFileManager-dialogDirectoryChooserMoveTitle": "Move to",
        // "dxFileManager-dialogDirectoryChooserMoveButtonText": "Move",
        // "dxFileManager-dialogDirectoryChooserCopyTitle": "Copy to",
        // "dxFileManager-dialogDirectoryChooserCopyButtonText": "Copy",
        // "dxFileManager-dialogRenameItemTitle": "Rename",
        // "dxFileManager-dialogRenameItemButtonText": "Save",
        // "dxFileManager-dialogCreateDirectoryTitle": "New directory",
        // "dxFileManager-dialogCreateDirectoryButtonText": "Create",
        // "dxFileManager-dialogDeleteItemTitle": "Delete",
        // "dxFileManager-dialogDeleteItemButtonText": "Delete",
        // "dxFileManager-dialogDeleteItemSingleItemConfirmation": "Are you sure you want to delete {0}?",
        // "dxFileManager-dialogDeleteItemMultipleItemsConfirmation": "Are you sure you want to delete {0} items?",
        // "dxFileManager-dialogButtonCancel": "Cancel",

        // "dxFileManager-editingCreateSingleItemProcessingMessage": "Creating a directory inside {0}",
        // "dxFileManager-editingCreateSingleItemSuccessMessage": "Created a directory inside {0}",
        // "dxFileManager-editingCreateSingleItemErrorMessage": "Directory was not created",
        // "dxFileManager-editingCreateCommonErrorMessage": "Directory was not created",

        // "dxFileManager-editingRenameSingleItemProcessingMessage": "Renaming an item inside {0}",
        // "dxFileManager-editingRenameSingleItemSuccessMessage": "Renamed an item inside {0}",
        // "dxFileManager-editingRenameSingleItemErrorMessage": "Item was not renamed",
        // "dxFileManager-editingRenameCommonErrorMessage": "Item was not renamed",

        // "dxFileManager-editingDeleteSingleItemProcessingMessage": "Deleting an item from {0}",
        // "dxFileManager-editingDeleteMultipleItemsProcessingMessage": "Deleting {0} items from {1}",
        // "dxFileManager-editingDeleteSingleItemSuccessMessage": "Deleted an item from {0}",
        // "dxFileManager-editingDeleteMultipleItemsSuccessMessage": "Deleted {0} items from {1}",
        // "dxFileManager-editingDeleteSingleItemErrorMessage": "Item was not deleted",
        // "dxFileManager-editingDeleteMultipleItemsErrorMessage": "{0} items were not deleted",
        // "dxFileManager-editingDeleteCommonErrorMessage": "Some items were not deleted",

        // "dxFileManager-editingMoveSingleItemProcessingMessage": "Moving an item to {0}",
        // "dxFileManager-editingMoveMultipleItemsProcessingMessage": "Moving {0} items to {1}",
        // "dxFileManager-editingMoveSingleItemSuccessMessage": "Moved an item to {0}",
        // "dxFileManager-editingMoveMultipleItemsSuccessMessage": "Moved {0} items to {1}",
        // "dxFileManager-editingMoveSingleItemErrorMessage": "Item was not moved",
        // "dxFileManager-editingMoveMultipleItemsErrorMessage": "{0} items were not moved",
        // "dxFileManager-editingMoveCommonErrorMessage": "Some items were not moved",

        // "dxFileManager-editingCopySingleItemProcessingMessage": "Copying an item to {0}",
        // "dxFileManager-editingCopyMultipleItemsProcessingMessage": "Copying {0} items to {1}",
        // "dxFileManager-editingCopySingleItemSuccessMessage": "Copied an item to {0}",
        // "dxFileManager-editingCopyMultipleItemsSuccessMessage": "Copied {0} items to {1}",
        // "dxFileManager-editingCopySingleItemErrorMessage": "Item was not copied",
        // "dxFileManager-editingCopyMultipleItemsErrorMessage": "{0} items were not copied",
        // "dxFileManager-editingCopyCommonErrorMessage": "Some items were not copied",

        // "dxFileManager-editingUploadSingleItemProcessingMessage": "Uploading an item to {0}",
        // "dxFileManager-editingUploadMultipleItemsProcessingMessage": "Uploading {0} items to {1}",
        // "dxFileManager-editingUploadSingleItemSuccessMessage": "Uploaded an item to {0}",
        // "dxFileManager-editingUploadMultipleItemsSuccessMessage": "Uploaded {0} items to {1}",
        // "dxFileManager-editingUploadSingleItemErrorMessage": "Item was not uploaded",
        // "dxFileManager-editingUploadMultipleItemsErrorMessage": "{0} items were not uploaded",
        // "dxFileManager-editingUploadCanceledMessage": "Canceled",

        // "dxFileManager-listDetailsColumnCaptionName": "Navn",
        // "dxFileManager-listDetailsColumnCaptionDateModified": "Dato endret",
        // "dxFileManager-listDetailsColumnCaptionFileSize": "Filstørrelse",

        // "dxFileManager-listThumbnailsTooltipTextSize": "Størrelse",
        // "dxFileManager-listThumbnailsTooltipTextDateModified": "Datomodifikator",

        // "dxFileManager-notificationProgressPanelTitle": "Framgang",
        // "dxFileManager-notificationProgressPanelEmptyListText": "Ingen operasjoner",
        // "dxFileManager-notificationProgressPanelOperationCanceled": "Avbrutt",

        // "dxDiagram-categoryGeneral": "General",
        // "dxDiagram-categoryFlowchart": "Flowchart",
        // "dxDiagram-categoryOrgChart": "Org Chart",
        // "dxDiagram-categoryContainers": "Containers",
        // "dxDiagram-categoryCustom": "Custom",

        // "dxDiagram-commandExportToSvg": "Export to SVG",
        // "dxDiagram-commandExportToPng": "Export to PNG",
        // "dxDiagram-commandExportToJpg": "Export to JPEG",
        // "dxDiagram-commandUndo": "Undo",
        // "dxDiagram-commandRedo": "Redo",
        // "dxDiagram-commandFontName": "Font Name",
        // "dxDiagram-commandFontSize": "Font Size",
        // "dxDiagram-commandBold": "Bold",
        // "dxDiagram-commandItalic": "Italic",
        // "dxDiagram-commandUnderline": "Underline",
        // "dxDiagram-commandTextColor": "Font Color",
        // "dxDiagram-commandLineColor": "Line Color",
        // "dxDiagram-commandLineWidth": "Line Width",
        // "dxDiagram-commandLineStyle": "Line Style",
        // "dxDiagram-commandLineStyleSolid": "Solid",
        // "dxDiagram-commandLineStyleDotted": "Dotted",
        // "dxDiagram-commandLineStyleDashed": "Dashed",
        // "dxDiagram-commandFillColor": "Fill Color",
        // "dxDiagram-commandAlignLeft": "Align Left",
        // "dxDiagram-commandAlignCenter": "Align Center",
        // "dxDiagram-commandAlignRight": "Align Right",
        // "dxDiagram-commandConnectorLineType": "Connector Line Type",
        // "dxDiagram-commandConnectorLineStraight": "Straight",
        // "dxDiagram-commandConnectorLineOrthogonal": "Orthogonal",
        // "dxDiagram-commandConnectorLineStart": "Connector Line Start",
        // "dxDiagram-commandConnectorLineEnd": "Connector Line End",
        // "dxDiagram-commandConnectorLineNone": "None",
        // "dxDiagram-commandConnectorLineArrow": "Arrow",
        // "dxDiagram-commandFullscreen": "Full Screen",
        // "dxDiagram-commandUnits": "Units",
        // "dxDiagram-commandPageSize": "Page Size",
        // "dxDiagram-commandPageOrientation": "Page Orientation",
        // "dxDiagram-commandPageOrientationLandscape": "Landscape",
        // "dxDiagram-commandPageOrientationPortrait": "Portrait",
        // "dxDiagram-commandPageColor": "Page Color",
        // "dxDiagram-commandShowGrid": "Show Grid",
        // "dxDiagram-commandSnapToGrid": "Snap to Grid",
        // "dxDiagram-commandGridSize": "Grid Size",
        // "dxDiagram-commandZoomLevel": "Zoom Level",
        // "dxDiagram-commandAutoZoom": "Auto Zoom",
        // "dxDiagram-commandFitToContent": "Fit to Content",
        // "dxDiagram-commandFitToWidth": "Fit to Width",
        // "dxDiagram-commandAutoZoomByContent": "Auto Zoom by Content",
        // "dxDiagram-commandAutoZoomByWidth": "Auto Zoom by Width",
        // "dxDiagram-commandSimpleView": "Simple View",
        // "dxDiagram-commandCut": "Cut",
        // "dxDiagram-commandCopy": "Copy",
        // "dxDiagram-commandPaste": "Paste",
        // "dxDiagram-commandSelectAll": "Select All",
        // "dxDiagram-commandDelete": "Delete",
        // "dxDiagram-commandBringToFront": "Bring to Front",
        // "dxDiagram-commandSendToBack": "Send to Back",
        // "dxDiagram-commandLock": "Lock",
        // "dxDiagram-commandUnlock": "Unlock",
        // "dxDiagram-commandInsertShapeImage": "Insert Image...",
        // "dxDiagram-commandEditShapeImage": "Change Image...",
        // "dxDiagram-commandDeleteShapeImage": "Delete Image",
        // "dxDiagram-commandLayoutLeftToRight": "Left-to-right",
        // "dxDiagram-commandLayoutRightToLeft": "Right-to-left",
        // "dxDiagram-commandLayoutTopToBottom": "Top-to-bottom",
        // "dxDiagram-commandLayoutBottomToTop": "Bottom-to-top",

        // "dxDiagram-unitIn": "in",
        // "dxDiagram-unitCm": "cm",
        // "dxDiagram-unitPx": "px",

        // "dxDiagram-dialogButtonOK": "OK",
        // "dxDiagram-dialogButtonCancel": "Cancel",
        // "dxDiagram-dialogInsertShapeImageTitle": "Insert Image",
        // "dxDiagram-dialogEditShapeImageTitle": "Change Image",
        // "dxDiagram-dialogEditShapeImageSelectButton": "Select image",
        // "dxDiagram-dialogEditShapeImageLabelText": "or drop file here",

        // "dxDiagram-uiExport": "Export",
        // "dxDiagram-uiProperties": "Properties",
        // "dxDiagram-uiSettings": "Settings",
        // "dxDiagram-uiShowToolbox": "Show Toolbox",
        // "dxDiagram-uiSearch": "Search",
        // "dxDiagram-uiStyle": "Style",
        // "dxDiagram-uiLayout": "Layout",
        // "dxDiagram-uiLayoutTree": "Tree",
        // "dxDiagram-uiLayoutLayered": "Layered",
        // "dxDiagram-uiDiagram": "Diagram",
        // "dxDiagram-uiText": "Text",
        // "dxDiagram-uiObject": "Object",
        // "dxDiagram-uiConnector": "Connector",
        // "dxDiagram-uiPage": "Page",

        // "dxDiagram-shapeText": "Tekst",
        // "dxDiagram-shapeRectangle": "Rectangle",
        // "dxDiagram-shapeEllipse": "Ellipse",
        // "dxDiagram-shapeCross": "Cross",
        // "dxDiagram-shapeTriangle": "Triangle",
        // "dxDiagram-shapeDiamond": "Diamond",
        // "dxDiagram-shapeHeart": "Heart",
        // "dxDiagram-shapePentagon": "Pentagon",
        // "dxDiagram-shapeHexagon": "Hexagon",
        // "dxDiagram-shapeOctagon": "Octagon",
        // "dxDiagram-shapeStar": "Star",
        // "dxDiagram-shapeArrowLeft": "Left Arrow",
        // "dxDiagram-shapeArrowUp": "Up Arrow",
        // "dxDiagram-shapeArrowRight": "Right Arrow",
        // "dxDiagram-shapeArrowDown": "Down Arrow",
        // "dxDiagram-shapeArrowUpDown": "Up Down Arrow",
        // "dxDiagram-shapeArrowLeftRight": "Left Right Arrow",
        // "dxDiagram-shapeProcess": "Process",
        // "dxDiagram-shapeDecision": "Decision",
        // "dxDiagram-shapeTerminator": "Terminator",
        // "dxDiagram-shapePredefinedProcess": "Predefined Process",
        // "dxDiagram-shapeDocument": "Document",
        // "dxDiagram-shapeMultipleDocuments": "Multiple Documents",
        // "dxDiagram-shapeManualInput": "Manual Input",
        // "dxDiagram-shapePreparation": "Preparation",
        // "dxDiagram-shapeData": "Data",
        // "dxDiagram-shapeDatabase": "Database",
        // "dxDiagram-shapeHardDisk": "Hard Disk",
        // "dxDiagram-shapeInternalStorage": "Internal Storage",
        // "dxDiagram-shapePaperTape": "Paper Tape",
        // "dxDiagram-shapeManualOperation": "Manual Operation",
        // "dxDiagram-shapeDelay": "Delay",
        // "dxDiagram-shapeStoredData": "Stored Data",
        // "dxDiagram-shapeDisplay": "Display",
        // "dxDiagram-shapeMerge": "Merge",
        // "dxDiagram-shapeConnector": "Connector",
        // "dxDiagram-shapeOr": "Or",
        // "dxDiagram-shapeSummingJunction": "Summing Junction",
        // "dxDiagram-shapeContainerDefaultText": "Container",
        // "dxDiagram-shapeVerticalContainer": "Vertical Container",
        // "dxDiagram-shapeHorizontalContainer": "Horizontal Container",
        // "dxDiagram-shapeCardDefaultText": "Person's Name",
        // "dxDiagram-shapeCardWithImageOnLeft": "Card with Image on the Left",
        // "dxDiagram-shapeCardWithImageOnTop": "Card with Image on the Top",
        // "dxDiagram-shapeCardWithImageOnRight": "Card with Image on the Right",

        "dxGantt-dialogTitle": "Tittel",
        "dxGantt-dialogStartTitle": "Start",
        "dxGantt-dialogEndTitle": "Slutt",
        "dxGantt-dialogProgressTitle": "Framgang",
        "dxGantt-dialogResourcesTitle": "Ressurser",
        "dxGantt-dialogResourceManagerTitle": "Ressursforvalter",
        "dxGantt-dialogTaskDetailsTitle": "Oppgavedetaljer",
        "dxGantt-dialogEditResourceListHint": "Rediger ressursliste",
        "dxGantt-dialogEditNoResources": "Ingen ressurser",
        "dxGantt-dialogButtonAdd": "Legg til",
        "dxGantt-contextMenuNewTask": "Ny oppgave",
        "dxGantt-contextMenuNewSubtask": "Ny deloppgaven",
        "dxGantt-contextMenuDeleteTask": "Slett oppgave",
        "dxGantt-contextMenuDeleteDependency": "Slett avhengighet",
        "dxGantt-dialogTaskDeleteConfirmation": "Hvis du sletter en oppgave, slettes også alle dens avhengigheter og deloppgaver. Er du sikker på at du vil slette denne oppgaven?",
        "dxGantt-dialogDependencyDeleteConfirmation": "Er du sikker på at du vil slette avhengigheten fra oppgaven?",
        "dxGantt-dialogResourcesDeleteConfirmation": "Hvis du sletter en ressurs, slettes den også fra oppgaver som denne ressursen er tilordnet. Er du sikker på at du vil slette disse ressursene? Ressurser {0}",
        "dxGantt-dialogConstraintCriticalViolationMessage": "Oppgaven du prøver å flytte er tilknyttet en annen oppgave av et avhengighetsforhold. Denne endringen vil være i konflikt med avhengighetsregler. Hvordan vil du fortsette?",
        "dxGantt-dialogConstraintViolationMessage": "Oppgaven du prøver å flytte er tilknyttet en annen oppgave av et avhengighetsforhold. Hvordan vil du fortsette?",
        "dxGantt-dialogCancelOperationMessage": "Avbryt operasjonen",
        "dxGantt-dialogDeleteDependencyMessage": "Slett avhengigheten",
        "dxGantt-dialogMoveTaskAndKeepDependencyMessage": "Flytt oppgaven og behold avhengigheten",
        "dxGantt-undo": "Angre",
        "dxGantt-redo": "Gjør om",
        "dxGantt-expandAll": "Ekspander alle",
        "dxGantt-collapseAll": "Kollaps alle",
        "dxGantt-addNewTask": "Legg til ny oppgave",
        "dxGantt-deleteSelectedTask": "Slett valgt oppgave",
        "dxGantt-zoomIn": "Zoom inn",
        "dxGantt-zoomOut": "Zoom ut",
        "dxGantt-fullScreen": "Fullskjerm",
        "dxGantt-quarter": "Q{0}"
      }
    });
  }
}
